<template>

  <el-tooltip class="item" effect="dark" :content="nome" placement="top-start">
    <div
      class="progress-bar"
      role="progressbar"
      :style="{ width: `${percentual}%` , backgroundColor : color} "
      :aria-valuenow="percentual"
      aria-valuemin="0"
      aria-valuemax="100">
      {{ valor }}
    </div>
  </el-tooltip>

</template>

<script>
  export default {
    name: "BarraProgresso",
    props: ['percentual', 'valor', 'color' , 'nome']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Ranking/BarraProgresso.vue